document.addEventListener("DOMContentLoaded", function () {
    function setupAccordion() {
        const shadowHost1 = document.querySelector("shopify-app-component, recharge-subscription-widget");

        if (shadowHost1 && shadowHost1.shadowRoot) {
            const shadowHost2 = shadowHost1.shadowRoot.querySelector("rc-selling-plans");

            if (shadowHost2 && shadowHost2.shadowRoot) {
                injectCustomStyles(shadowHost2.shadowRoot);

                const fieldset = shadowHost2.shadowRoot.querySelector(".rc-plans-button-list");

                if (fieldset) {
                    const labels = fieldset.querySelectorAll("label");

                    if (labels.length === 0) return;

                    labels.forEach((label, index) => {
                        if (!label.querySelector("input[type='radio']")) {
                            const radioButton = document.createElement("input");
                            radioButton.type = "radio";
                            radioButton.name = "subscription_plan";
                            radioButton.value = `plan_${index + 1}`;
                            radioButton.classList.add("custom-radio");

                            label.prepend(radioButton);

                            radioButton.addEventListener("change", function () {
                                updateActiveLabel(fieldset);
                            });
                        }

                        // Inject subscription price into the label
                        const price = getSubscriptionPrice(index);
                        const priceSpan = document.createElement("span");
                        priceSpan.className = "subscription-price";
                        priceSpan.style.marginLeft = "10px";
                        priceSpan.style.fontWeight = "normal";

                        priceSpan.textContent = `(${price})`;

                        if (!label.querySelector(".subscription-price")) {
                            label.appendChild(priceSpan);
                        }

                        // Accordion functionality
                        label.addEventListener("click", function () {
                            fieldset.querySelectorAll(".accordion-content").forEach(el => el.remove());

                            const jsonObject = getMetafieldText(index);
                            const parsedContent = parseShopifyRichText(jsonObject);

                            const accordionContent = document.createElement("div");
                            accordionContent.className = "accordion-content";
                            accordionContent.style.padding = "10px";
                            accordionContent.style.border = "1px solid #153C64";
                            accordionContent.style.marginTop = "-12px";
                            accordionContent.style.borderRadius = "0px 0px 4px 4px";
                            accordionContent.style.background = "#f9f9f9";
                            accordionContent.style.fontSize = "14px";

                            accordionContent.appendChild(parsedContent);

                            label.insertAdjacentElement("afterend", accordionContent);

                            updateActiveLabel(fieldset);
                        });
                    });

                    openFirstAccordion(fieldset, labels);
                } else {
                    setTimeout(setupAccordion, 500);
                }
            } else {
                setTimeout(setupAccordion, 500);
            }
        } else {
            setTimeout(setupAccordion, 500);
        }
    }

    // function getSubscriptionPrice(index) {
    //     const prices = window.productPrices?.prices || [];
    //     return prices[index] || "Price not available";
    // }


  function getSubscriptionPrice(index) {
        const metafields = window.productPrices || {};
        const metafieldKeys = Object.keys(metafields);

        // Assume metafields contain plain text price values
        const price = metafields[metafieldKeys[index]];
        return price || "Price not available";
    }
  

    function getMetafieldText(index) {
        const metafields = window.productMetafields || {};
        const metafieldKeys = Object.keys(metafields);
        const value = metafields[metafieldKeys[index]];

        if (!value) {
            return "No description available.";
        }

        // Return JSON object if valid
        if (typeof value === "object") {
            return value;
        }

        console.error("Unexpected metafield format:", value);
        return "Invalid metafield format.";
    }

    function parseShopifyRichText(jsonObject) {
        if (!jsonObject || jsonObject.type !== "root" || !Array.isArray(jsonObject.children)) {
            console.error("Invalid rich text structure:", jsonObject);
            return document.createTextNode("No content available.");
        }

        const fragment = document.createDocumentFragment();

        function renderNode(node) {
            if (node.type === "text") {
                const textNode = document.createTextNode(node.value || "");
                if (node.bold) {
                    const strong = document.createElement("strong");
                    strong.appendChild(textNode);
                    return strong;
                }
                return textNode;
            }

            if (node.type === "paragraph") {
                const p = document.createElement("p");
                if (node.children) {
                    node.children.forEach(child => {
                        const childNode = renderNode(child);
                        if (childNode) p.appendChild(childNode);
                    });
                }
                return p;
            }

            if (node.type === "list") {
                const listType = node.listType === "ordered" ? "ol" : "ul";
                const list = document.createElement(listType);
                if (node.children) {
                    node.children.forEach(child => {
                        const listItem = renderNode(child);
                        if (listItem) list.appendChild(listItem);
                    });
                }
                return list;
            }

            if (node.type === "list-item") {
                const li = document.createElement("li");
                if (node.children) {
                    node.children.forEach(child => {
                        const childNode = renderNode(child);
                        if (childNode) li.appendChild(childNode);
                    });
                }
                return li;
            }

            console.warn("Unsupported node type:", node.type);
            return document.createTextNode(""); // Fallback for unsupported types
        }

        jsonObject.children.forEach(child => {
            const childNode = renderNode(child);
            if (childNode) fragment.appendChild(childNode);
        });

        return fragment;
    }

    function openFirstAccordion(fieldset, labels) {
        if (labels.length > 0) {
            fieldset.querySelectorAll(".accordion-content").forEach(el => el.remove());

            const firstLabel = labels[0];
            const firstRadio = firstLabel.querySelector("input[type='radio']");

            if (firstRadio) {
                firstRadio.checked = true;
            }

            const jsonObject = getMetafieldText(0);
            const parsedContent = parseShopifyRichText(jsonObject);

            const accordionContent = document.createElement("div");
            accordionContent.className = "accordion-content";
            accordionContent.style.padding = "10px";
            accordionContent.style.border = "1px solid #153C64";
            accordionContent.style.marginTop = "-12px";
            accordionContent.style.borderRadius = "0px 0px 4px 4px";
            accordionContent.style.background = "#f9f9f9";
            accordionContent.style.fontSize = "14px";

            accordionContent.appendChild(parsedContent);

            firstLabel.insertAdjacentElement("afterend", accordionContent);
            updateActiveLabel(fieldset);
        }
    }

    function updateActiveLabel(fieldset) {
        const labels = fieldset.querySelectorAll("label");
        labels.forEach(label => {
            const radio = label.querySelector("input[type='radio']");
            if (radio && radio.checked) {
                label.classList.add("active-label");
            } else {
                label.classList.remove("active-label");
            }
        });
    }

    function injectCustomStyles(shadowRoot) {
        if (!shadowRoot.querySelector("#custom-style")) {
            const style = document.createElement("style");
            style.id = "custom-style";
            style.textContent = `
                .rc-plans-button-list label {
                    display: flex;
                    align-items: center;
                    font-weight: bold;
                    cursor: pointer;
                    padding: 8px;
                    border: 1px solid transparent;
                    transition: all 0.3s ease-in-out;
                    border-radius: 4px;
                }

                .rc-plans-button-list label:hover {
                    background-color: #d0d8e0; 
                    border-radius: 4px 4px 0px 0px;
                }
                
                .rc-plans-button-list [data-checked]{
                    background-color: #153C64; 
                    border-radius: 4px 4px 0px 0px !important;
                }

                .active-label {
                    border-radius: 4px 4px 0px 0px !important;
                }

                .rc-plans-button-list label {
                    background-color: #e9ebf0 !important; 
                }

                .rc-plans-button:hover {
                    background-color: inherit !important;
                }

                .rc-purchase-option[rc-selected] {
                    border-color: #ffffff !important;
                }

                .rc-purchase-option {
                    border-color: #ffffff !important;
                }

                input {
                    position: relative !important;
                    width: 14px !important;
                    height: 14px !important;
                }

                .rc-purchase-option__subscription {
                    border: 1px solid #fff !important;
                }


                .rc-plans-button-list label.active-label {
                    background-color: #153C64 !important;
                    color: #fff;
                }
                .subscription-price {
                min-width: 20%;
                }
                .rc-plans-button-list .rc-plans-button {
    font-weight: 600 !important;
    font-family: Futura !important;
    font-size: 1.15em !important;
}
            `;
            shadowRoot.appendChild(style);
        }
    }

    setupAccordion();

    const observer = new MutationObserver(setupAccordion);
    observer.observe(document.body, { childList: true, subtree: true });
});

